/* assets/cart-upsell.js
   Añade productos de "Te podría interesar" al carrito sin recargar la página
   y sin cerrar el drawer. Reusa el mismo mecanismo de Section Rendering API
   que ya usa cart-drawer-items (cart.js) para quitar/cambiar cantidad. */
if (!customElements.get('cart-upsell')) {
  class CartUpsell extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick.bind(this));
    }
 
    onClick(event) {
      const button = event.target.closest('.cart-upsell__btn');
      if (!button || button.disabled) return;
      this.addToCart(button);
    }
 
    async addToCart(button) {
      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = 'Añadiendo…';
 
      const variantId = button.dataset.variantId;
      const cartDrawer = document.querySelector('cart-drawer');
      const cartDrawerItems = document.querySelector('cart-drawer-items');
 
      try {
        const addResponse = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });
 
        if (!addResponse.ok) {
          const err = await addResponse.json().catch(() => ({}));
          throw new Error(err.description || 'No se pudo añadir el producto');
        }
 
        if (cartDrawer && cartDrawerItems) {
          // getSectionsToRender vive en cart-drawer-items (CartDrawerItems extends CartItems).
          // renderContents vive en cart-drawer (CartDrawer). Hay que combinar ambos.
          await customElements.whenDefined('cart-drawer');
          await customElements.whenDefined('cart-drawer-items');
 
          if (typeof cartDrawerItems.getSectionsToRender === 'function'
              && typeof cartDrawer.renderContents === 'function') {
            const sections = cartDrawerItems.getSectionsToRender().map((s) => s.section || s.id);
            const sectionsParam = encodeURIComponent(sections.join(','));
            const stateResponse = await fetch(
              `${window.location.pathname}?sections=${sectionsParam}`
            );
            const sectionsHTML = await stateResponse.json();
            cartDrawer.renderContents({ id: variantId, sections: sectionsHTML });
          }
        }
 
        button.textContent = '✓ Añadido';
      } catch (error) {
        console.error('[cart-upsell]', error);
        button.textContent = 'Error, reintenta';
      } finally {
        setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
        }, 1500);
      }
    }
  }
 
  customElements.define('cart-upsell', CartUpsell);
}